const badgeColorVariants = [
  "red",
  "orange",
  "amber",
  "yellow",
  "lime",
  "green",
  "emerald",
  "teal",
  "cyan",
  "sky",
  "blue",
  "indigo",
  "violet",
  "purple",
  "fuchsia",
  "pink",
  "rose",
] as const;

export type BadgeColorVariant = (typeof badgeColorVariants)[number] | "neutral";

function fnv1a(str: string): number {
  let hash = 0x81_1c_9d_c5;
  for (let i = 0; i < str.length; i++) {
    // biome-ignore lint/suspicious/noBitwiseOperators: FNV-1a hash requires bitwise operators
    hash ^= str.charCodeAt(i);
    // biome-ignore lint/suspicious/noBitwiseOperators: FNV-1a hash requires unsigned right shift
    hash = (hash * 0x01_00_01_93) >>> 0;
  }
  return hash;
}

export function getBadgeColorVariant(
  value: string | undefined
): BadgeColorVariant {
  if (!value) {
    return "neutral";
  }
  const hash = fnv1a(value.toLowerCase().trim());
  return badgeColorVariants[hash % badgeColorVariants.length] ?? "neutral";
}

export const JOB_STATUS_COLOR_MAP: Record<string, BadgeColorVariant> = {
  active: "emerald",
  published: "emerald",
  draft: "neutral",
  archived: "neutral",
  closed: "neutral",
};

export const APPLICATION_STATUS_COLOR_MAP: Record<string, BadgeColorVariant> = {
  submitted: "blue",
  shortlisted: "sky",
  interviewing: "indigo",
  verification_pending: "violet",
  accepted: "emerald",
  rejected: "neutral",
  withdrawn: "neutral",
  archived: "neutral",
  draft: "neutral",
};
